import designer from '@/view/activities/2020-designer'
// 设计师合伙人
import designerApplication from '@/view/activities/designer/index.vue'
// 申请设计师合伙人
import apply from '@/view/activities/designer/apply.vue'
// 合伙人三大权益
import rAndI from '@/view/activities/designer/rAndI.vue'
// 项目登记表
import projecrRegin from '@/view/activities/designer/projectRegistration.vue'
// 品牌推荐
import recommendation from '@/view/activities/designer/recommendation.vue'

const activitiesRouter = [{
  path: '/activity/dsg/selection.html',
  name: 'designer-2020',
  component: designer,
  meta: {
    title: '执笔智能 设计未来'
  }
},
{
  path: '/activity/dsg/designer.html',
  name: 'designerApplication',
  component: designerApplication,
  meta: {
    title: '设计师合伙人'
  }
},
{
  path: '/activity/dsg/apply.html',
  name: 'apply',
  component: apply,
  meta: {
    title: '设计师合伙人申请'
  }
},
{
  path: '/activity/dsg/randi.html',
  name: 'rAndI',
  component: rAndI,
  meta: {
    title: '合伙人三大权益'
  }
},
{
  path: '/activity/dsg/projeceRegin.html',
  name: 'projecrRegin',
  component: projecrRegin,
  meta: {
    title: '项目登记表'
  }
},
{
  path: '/activity/dsg/recommendation.html',
  name: 'recommendation',
  component: recommendation,
  meta: {
    title: '品牌推荐表单'
  }
},

]

export default activitiesRouter



// WEBPACK FOOTER //
// ./src/router/activities/index.js